import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { App } from './App';
import { PalaceHotelApp } from './subsidiaries/palace-hotel/PalaceHotelApp';
import { StandardPurityApp } from './subsidiaries/standard-purity/StandardPurityApp';
import { PuritydefineApp } from './subsidiaries/puritydefine/PuritydefineApp';
import { UniqueBukaApp } from './subsidiaries/unique-buka/UniqueBukaApp';
export function AppRouter() {
  return <BrowserRouter data-id="element-8">
      <Routes data-id="element-9">
        <Route path="/" element={<App data-id="element-11" />} data-id="element-10" />
        <Route path="/palace-hotel/*" element={<PalaceHotelApp data-id="element-13" />} data-id="element-12" />
        <Route path="/standard-purity/*" element={<StandardPurityApp data-id="element-15" />} data-id="element-14" />
        <Route path="/puritydefine/*" element={<PuritydefineApp data-id="element-17" />} data-id="element-16" />
        <Route path="/unique-buka/*" element={<UniqueBukaApp data-id="element-19" />} data-id="element-18" />
      </Routes>
    </BrowserRouter>;
}